import { InferenceForm as InferenceFormPayloadType } from "../../types";

export type FilterType = "search" | "tab";

export const FILTERS = {
  SEARCH: "search",
  TAB: "tab",
} as const;

export const DEFAULT_FILTERS_VALUES = {
  [FILTERS.SEARCH]: "",
  [FILTERS.TAB]: "all",
} as const;

export const DEFAULT_INFERENCE_FORM: InferenceFormPayloadType = {
  defaults: {
    initImageWeight: 0.5,
    controlnetImageWeight: 1,
  },
  parameters: {
    generationType: "CREATE",
    batchSize: 4,
    width: 1024,
    height: 1024,
    prompt: "",
    seed: -1,
    numInferenceSteps: 20,
    guidanceScale: 4,
  },
};

export const FORGE_ERROR_DURATION_MS = 4000;
export const NUM_INITIAL_INFERENCES = 8;
export const NUM_INFERENCE_PER_PAGE = 8;
export const DEFAULT_FORGE_SESSION_NAME = "Untitled";
export const NEW_SESSION_ID = "new";
